import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from 'lib/utils';
import BPIcon from '../icons/BPIcon';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-[40px] w-[40px] bg-transparent ring-offset-background focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
      // data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <BPIcon icon="check" className="fill-[#01EF7F]" />
    </CheckboxPrimitive.Indicator>
    {props.children}
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
